/** How many placeholder rows the list shows while loading. */
export const GROUPED_LIST_LOADING_ROW_COUNT = 3;
